import logo from "../images/RT-logo-alt.png";

function Footer() {
  return (
<footer className="footer footer-center bg-zinc-800 font-rescue p-4 md:p-10" id="footer">
      <div className="container mx-auto">
        <img
          src={logo}
          width={200}
          className="hidden md:block rounded-xl p-2 mx-auto mb-4"
          alt="logo"
        />
        <nav className="grid grid-flow-col gap-4 mb-4">
          <a href="/about-us" className="link hover:!text-white no-underline">About Us</a>
          <a href="#features" className="link hover:!text-white no-underline">Services</a>
          <a href="#footer" className="link hover:!text-white no-underline">Contact Us</a>
        </nav>
        <nav className="mb-4">
        <div className="grid grid-flow-col gap-4">
          <a
            href="https://instagram.com/rescuetyres"
            target="_blank"
            rel="noreferrer"
            className="hover:!text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
            </svg>
          </a>
          <a
            href="https://www.facebook.com/people/Rescue-Tyres/61560775450756"
            target="_blank"
            rel="noreferrer"
            className="hover:!text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
            </svg>
          </a>
          <a
            href="https://www.tiktok.com/@rescuetyres"
            target="_blank"
            rel="noreferrer"
            className="hover:!text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
            </svg>
          </a>
          <a
            href="mailto:rescuetyresltd@outlook.com"
            className="hover:!text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"></path>
            </svg>
          </a>
          <a href="tel:+44747320871" className="hover:!text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-current"
            >
              <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
            </svg>
          </a>
        </div>
      </nav>
      <div className="flex flex-col md:flex-row justify-center items-center !text-white text-sm md:text-lg mb-4">
          <a href="mailto:rescuetyresltd@outlook.com" className="!text-white font-expo hover:!text-rescueRed mb-2 md:mb-0 md:mr-2">rescuetyresltd@outlook.com</a>
          <span className="hidden md:inline">|</span>
          <a href="tel:+44747320871" className="!text-white font-expo hover:!text-rescueRed mb-2 md:mb-0 md:mx-2">+44(0) 7473 20871</a>
          <span className="hidden md:inline">|</span>
          <span className="font-expo hover:underline hover:text-rescueRed text-center mb-2 md:mb-0 md:mx-2"> 964 North Circular Road, NW2 7JR</span>
        </div>
        <aside>
          <p className="text-zinc-500 text-sm">
            Copyright © {new Date().getFullYear()} - All rights reserved by Rescue Tyres Ltd
          </p>
        </aside>
      </div>
    </footer>
  );
}

export default Footer;
